export default function accordeonModule() {
  const accordeons = Array.from(document.querySelectorAll("[data-accordeon]"))

  const setContentHeight = (accordeon, isOpen) => {
    const content = accordeon.querySelector(".accordion-card__content")

    if (!content) {
      return
    }

    if (isOpen) {
      content.style.maxHeight = `${content.scrollHeight}px`
      return
    }

    content.style.maxHeight = `${content.scrollHeight}px`
    requestAnimationFrame(() => {
      content.style.maxHeight = "0px"
    })
  }

  accordeons.forEach((accordeon) => {
    const isOpen = accordeon.getAttribute("data-accordeon") === "true"
    const content = accordeon.querySelector(".accordion-card__content")

    if (content) {
      content.style.maxHeight = isOpen ? "none" : "0px"
    }

    accordeon.addEventListener("click", () => {
      const isOpen = accordeon.getAttribute("data-accordeon") === "true"
      const nextState = !isOpen

      accordeon.setAttribute("data-accordeon", nextState)
      accordeon.classList.toggle("closed", !nextState)
      setContentHeight(accordeon, nextState)
    })
  })
}
